
<div class="notification-template-section">

  <div class="modal-header sticky-header">

    <div class="row">
      <h5 class="modal-title align-self-center col" id="profileModalLabel">{{ messageTemplate.notificationName }}</h5>
      <div class="col-auto text-end pt-3">
        <button class="btn btn-secondary me-2" type="button" (click)="cancel()"><i class="fa fa-times"></i> Cancel</button>
        <button type="button" class="btn btn-primary btn-primary-color" [disabled]="!messageTemplate.isEmail && !messageTemplate.isSMS" (click)="confirm()">
        <i class="fa fa-check"></i>  {{labelSubmitButton}}
        </button>
      </div>
    </div>
  </div>
  <div class="modal-body">

    <div class="data-grid table-responsive p-0" *ngIf="allowGrouping">
      <table class="table">
        <thead>
          <tr>
            <th>
              <input type="checkbox" [(ngModel)]="templateSelection.selectAllChecked" (change)="methods.toggleSelectAll()" />
            </th>
            <th>
              <ng-container *ngIf="messageTemplate.notificationTypeId == 110; else defaultName">
                Consignor
              </ng-container>
              <ng-template #defaultName>
                Vet
              </ng-template>
            </th>

            <th>Phone</th>
            <th>Email</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let clinic of methods.getGroupedClinicNames()">
            <!-- Group Header Row -->
            <tr class="table-group-header bg-light">
              <td style="padding-left:20px">
                <input type="checkbox"
                       [checked]="methods.isGroupFullySelected(clinic)"
                       (change)="methods.toggleGroupSelection(clinic, $event)" />
              </td>
              <td colspan="3"><strong>{{ clinic }}</strong></td>
            </tr>

            <!-- Child Rows -->
            <tr *ngFor="let member of groupedMembers[clinic]">
              <td style="padding-left:30px">
                <input type="checkbox" [(ngModel)]="member.isSelected" (change)="methods.toggleSelection()" />
              </td>
              <td>{{ member.userName }}</td>
              <td>{{ member.phone }}</td>
              <td>{{ member.email }}</td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>

    <div class="data-grid table-responsive pb-0" *ngIf="!allowGrouping">
      <table class="table">
        <thead>
          <tr>
            <!-- Select All Checkbox -->
            <th>
              <input type="checkbox" [(ngModel)]="templateSelection.selectAllChecked" (change)="methods.toggleSelectAll()" />
            </th>
            <th>Vet</th>
            <th>Clinic</th>
            <th *ngIf="isViewingList">View Date</th>
            <th *ngIf="!isViewingList">Submit Date</th>
            <th>Phone</th>
            <th>Email</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let member of methods.getMembers()">
            <!-- Checkbox for individual row -->
            <td>
              <input type="checkbox" [(ngModel)]="member.isSelected" (change)="methods.toggleSelection()" />
            </td>
            <td>{{ member.userName }}</td>
            <td>{{ member.memberName }}</td>
            <td>{{ member.submitOrViewDate | date: 'short' }}</td>
            <td>{{ member.phone }}</td>
            <td>{{ member.email }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="row ps-1">
      <div class="col-12">
        <div class="mb-2">
          <div class="form-check form-check-inline">
            <input class="form-check-input"
                   type="checkbox"
                   id="inlineCheckboxEmail"
                   value="email"
                   (click)="methods.emailChangedManual()"
                   [(ngModel)]="messageTemplate.isEmail">
            <label class="form-check-label" for="inlineCheckboxEmail">Email</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input"
                   type="checkbox"
                   id="inlineCheckboxSMS"
                   value="sms"
                   (click)="methods.smsChangedManual()"
                   [disabled]="isPhoneNotExist"
                   [(ngModel)]="messageTemplate.isSMS">
            <label class="form-check-label" for="inlineCheckboxSMS">SMS</label>
          </div>
        </div>

        <div class="mb-2">
          <label for="subject">Subject</label>
          <input type="text" id="subject" [(ngModel)]="messageTemplate.subject" [disabled]="!messageTemplate.isEmail" name="subject" class="form-control" />
        </div>

        <div class="mb-2">
          <label for="emailMessage">Email Message</label>
          <textarea id="emailMessage" [(ngModel)]="messageTemplate.emailMessage" [disabled]="!messageTemplate.isEmail" name="emailMessage" rows="5"
                    class="form-control"></textarea>
        </div>

        <div>
          <label for="smsMessage">SMS Message</label>
          <textarea id="smsMessage" [(ngModel)]="messageTemplate.smsMessage" [disabled]="!messageTemplate.isSMS" name="smsMessage" rows="2"
                    class="form-control"></textarea>
        </div>
      </div>
    </div>


  </div>


</div>

